
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 20 20","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11 3a1 1 0 10-2 0h2zm-1 10l-.707.707.707.707.707-.707L10 13zM6.707 8.293a1 1 0 00-1.414 1.414l1.414-1.414zm8 1.414a1 1 0 00-1.414-1.414l1.414 1.414zM4 13a1 1 0 10-2 0h2zm-1 4H2a1 1 0 001 1v-1zm14 0v1a1 1 0 001-1h-1zm1-4a1 1 0 10-2 0h2zM9 3v10h2V3H9zM5.293 9.707l4 4 1.414-1.414-4-4-1.414 1.414zm5.414 4l4-4-1.414-1.414-4 4 1.414 1.414zM2 13v4h2v-4H2zm1 5h14v-2H3v2zm15-1v-4h-2v4h2z","fill":"currentColor"}})])
          )
        }
      }
    